import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CanmapSaveConfirmationData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-canmap-save-confirmation-dialog',
  templateUrl: './canmap-save-confirmation-dialog.component.html',
  styleUrls: ['./canmap-save-confirmation-dialog.component.scss'],
})
export class CanmapSaveConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CanmapSaveConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CanmapSaveConfirmationData,
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
